(function (app, ehs) {

    var MasterPassModel = Backbone.Model.extend({

        pay: function (token, onSuccess, onError) {
            var scriptAddress = ehs ?
                'https://masterpass.com/lightbox/Switch/integration/MasterPass.client.js' :
                'https://sandbox.masterpass.com/lightbox/Switch/integration/MasterPass.client.js';

            $.when(app.checkout.masterPassPayment(), $.getScript(scriptAddress))
                .done(_.bind(this._showPopup, this, token, onSuccess, onError));
        },

        checkQueryParams: function (queryParams, onSuccess) {
            if (queryParams.oauth_token && queryParams.oauth_verifier) {
                this._confirm(onSuccess, queryParams);
            }
        },

        _showPopup: function (token, onSuccess, onError, data) {
            var details = data.Value;
            var checkoutParams = {
                "requestToken": details.RequestToken,
                "callbackUrl": location.protocol + '//' + location.host + location.pathname,
                "successCallback": _.bind(this._confirm, this, onSuccess),
                "failureCallback": onError,
                "merchantCheckoutId": details.CheckoutID,
                "allowedCardTypes": [details.AllowedCardTypes],
                "version": details.Version,
                "suppressShippingAddressEnable": details.ShippingSupression,
                "cancelCallback": location.protocol + '//' + location.host + location.pathname,
                "requestBasicCheckout": false
            };

            if (details.RequestPairing) {
                $.extend(checkoutParams, {
                    "pairingRequestToken": details.PairingRequestToken,
                    "requestedDataTypes": details.RequestedDataTypes,
                    "requestPairing": true
                });
            } else {
                $.extend(checkoutParams, {
                    "cardId": token || details.CardID,
                    "shippingId": details.AddressID,
                    "precheckoutTransactionId": details.PrecheckoutTransactionID,
                    "walletName": details.WalletName,
                    "consumerWalletId": details.WalletID
                });
            }

            MasterPass.client.checkout(checkoutParams);
        },

        _confirm: function (onSuccess, data) {
            api.masterPassPostTransaction({
                OAuthToken: data.oauth_token,
                OAuthVerifier: data.oauth_verifier,
                CheckoutResourceUrl: data.checkout_resource_url,
                PairingToken: data.pairing_token,
                PairingVerifier: data.pairing_verifier,
                IsMobile: false
            }, { wait: true }).done(onSuccess);
        }
    });

    app.models = _.extend({ masterpass: new MasterPassModel() }, app.models);
})(app, GlobalSettings.EHS);